export default __webpack_public_path__ + "static/media/Homepage.cd9f05ac.jpg";